package com.essntl.features.itinerary.domain.model

sealed class ItineraryOrderType(val orderName: String) {
    data object Alphabetical : ItineraryOrderType("Title, A-Z")

    data object LastCreated : ItineraryOrderType("Last created")

    data object StartDate : ItineraryOrderType("Start date")

    companion object {
        val Default = StartDate
    }
}
